export const DEFAULT_ZOOM_LABEL = "Open fullscreen zoom"
